import { combineReducers } from 'redux';

import oidcReducer from './oidc/slice';
import alert from './alerts/slice';
import selectedLoad from './selected-load/slice';
import updatedLoad from './updated-load/slice';
import metadata from './metadata/slice';
import loadDetails from './load-details/slice';
import loadSummary from './load-summary/slice';
import profileSettings from './profile-settings/slice';
import modeType from './mode/slice';

const rootReducers = combineReducers({
  alert,
  oidc: oidcReducer,
  selectedLoad,
  updatedLoad,
  loadDetails,
  loadSummary,
  metadata,
  profileSettings,
  modeType,
});

export default rootReducers;
